import {
  faInstagram,
  faTiktok,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactNode } from 'react';

export const CreatorsListStats = ({
  profileInstagram,
  instagramFollowersCount,
  profileYoutubeChannel,
  profileTiktok,
}: {
  profileInstagram?: string;
  instagramFollowersCount?: number;
  profileTiktok?: string;
  profileYoutubeChannel?: string;
}) => {
  return (
    <div className="flex gap-6 items-center">
      <LinkWrapper link={profileInstagram} type="instagram">
        <div className="text-gray-4">
          <FontAwesomeIcon icon={faInstagram} className="pr-2" />
          {instagramFollowersCount
            ? Intl.NumberFormat('en', {
                notation: 'compact',
                maximumFractionDigits: 1,
              }).format(instagramFollowersCount)
            : null}
        </div>
      </LinkWrapper>
      {profileYoutubeChannel ? (
        <LinkWrapper link={profileYoutubeChannel} type="youtube">
          <div className="text-gray-4">
            <FontAwesomeIcon icon={faYoutube} />
          </div>
        </LinkWrapper>
      ) : null}
      {profileTiktok ? (
        <LinkWrapper link={profileTiktok} type="tiktok">
          <div className="text-gray-4">
            <FontAwesomeIcon icon={faTiktok} />
          </div>
        </LinkWrapper>
      ) : null}
    </div>
  );
};

type SocialType = 'instagram' | 'youtube' | 'tiktok';
const LinkWrapper = ({
  children,
  type,
  link,
}: {
  children: ReactNode;
  type: SocialType;
  link?: string;
}) => {
  if (link) {
    return (
      <a href={getSocialLink(link, type)} target="_blank" rel="noreferrer">
        {children}
      </a>
    );
  }
  return children;
};

const getSocialLink = (link: string, type: SocialType) => {
  switch (type) {
    case 'instagram':
      return `https://www.instagram.com/${link}`;
    case 'youtube':
      return link;
    case 'tiktok':
      return link.startsWith('@')
        ? `https://www.tiktok.com/${link}`
        : `https://tiktok.com/@${link}`;
  }
};
